import './src/styles/index.scss';

import { ActionContextProvider, createConfig } from './src/cra';

import BrandLogoContextProvider from './src/context/BrandLogoContextProvider';
import Cookies from 'universal-cookie';
import React from 'react';
import addressSectionExitIntentUtils from './src/utils/addressSectionExitIntentUtils';
import { posthog } from 'posthog-js';

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  const hash = window.location.hash;
  const hashParams = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const distinctId = hashParams.get('distinct_id');
  const sessionId = hashParams.get('session_id');

  const initOptions = {
    api_host: process.env.GATSBY_POSTHOG_HOST,
    capture_pageview: false,
  };

  if (distinctId && sessionId) {
    initOptions.bootstrap = { distinctID: distinctId, sessionID: sessionId };
  }

  posthog.init(process.env.GATSBY_POSTHOG_API_KEY, initOptions);
};

export const onRouteUpdate = () => {
  if (typeof posthog !== 'undefined') {
    posthog.capture('$pageview');
  }
};

export const wrapRootElement = ({ element }) => {
  createConfig({
    website: 'Demographics',
  });

  if (typeof window !== 'undefined') {
    const cookies = new Cookies();
    cookies.remove('exit-intent', {
      path: '/',
      domain: window.location.hostname,
    });
  }

  return (
    <ActionContextProvider
      exitIntentCallback={addressSectionExitIntentUtils.exitIntentCallback}
      routeToQuotingTool={addressSectionExitIntentUtils.routeToQuotingTool}
    >
      <BrandLogoContextProvider>{element}</BrandLogoContextProvider>
    </ActionContextProvider>
  );
};
